<template>
  <EmulatorCustomizationInputWrapper :label="label">
    <div class="row">
      <slot :value="value"></slot>
      <div class="col">
        <div class="form-group">
          <div class="input-group">
            <input
              v-if="isInput"
              class="form-control"
              :class="{ 'is-invalid': validationError }"
              :placeholder="placeholderValue"
              type="text"
              v-model="mutatedValue"
              @input="inputHandler"
            />
            <textarea
              v-else-if="isTextArea"
              class="form-control"
              :class="{ 'is-invalid': validationError }"
              :placeholder="placeholderValue"
              type="text"
              v-model="mutatedValue"
              @input="inputHandler"
            />
            <EmulatorCustomizationResetToDefault
              :disabled="!mutatedValue"
              :onClickHandler="resetToDefaultValue"
              toolTip="Reset to Default"
            />
          </div>
          <div v-if="validationError" class="invalid-feedback d-block">
            {{ validationError }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="$slots.postInput" class="row">
      <div class="col">
        <slot name="postInput"></slot>
      </div>
    </div>
  </EmulatorCustomizationInputWrapper>
</template>

<script>
import customThemeActions from '@/mixins/custom-theme-actions'
import EmulatorCustomizationInputWrapper from '@/components/Modules/Emulator/CustomizationInputs/EmulatorCustomizationInputWrapper'
import EmulatorCustomizationResetToDefault from '@/components/Modules/Emulator/CustomizationInputs/EmulatorCustomizationResetToDefault'

export default {
  name: 'EmulatorCustomizationTextBox',
  components: {
    EmulatorCustomizationInputWrapper,
    EmulatorCustomizationResetToDefault,
  },
  props: {
    inputType: {
      type: String,
      default: 'input',
      validator: (value) => value === 'input' || value === 'textarea',
    },
    placeholder: {
      type: String,
    },
    // Optional validator. Receives the raw input value and returns an error
    // message string when invalid, or a falsy value when valid. When set and
    // the input is invalid, the value is not pushed into pendingMutations so
    // we never persist or live-preview a malformed value.
    validator: {
      type: Function,
      default: undefined,
    },
  },
  mixins: [customThemeActions],
  data: () => ({
    validationError: '',
  }),
  computed: {
    isInput() {
      return this.inputType === 'input'
    },
    isTextArea() {
      return this.inputType === 'textarea'
    },
    placeholderValue() {
      return this.defaultValue ? this.defaultValue : this.placeholder
    },
  },
  methods: {
    inputHandler(event) {
      const rawValue = event.target.value

      if (rawValue && this.validator) {
        const error = this.validator(rawValue)
        if (error) {
          this.validationError = error
          return
        }
      }

      this.validationError = ''
      this.emitMutationEvents({ value: rawValue || this.defaultValue, action: 'update' })
    },
  },
  watch: {
    mutatedValue(newValue) {
      // Clear any validation error when the field is emptied (e.g. via the
      // reset-to-default button) so the user isn't left staring at an error
      // for a value they no longer have.
      if (!newValue) this.validationError = ''
    },
  },
}
</script>
